<template>
    <v-container id="logContainer" fill-height fluid class="logbook-page pa-0">
        <v-row no-gutters class="fill-height logbook-layout">
            <v-col cols="12" class="fill-height d-flex flex-column logbook-content">
                <v-row no-gutters class="logbook-header-row">
                    <v-sheet color="black" tile height="60px" width="100%" class="blackSheetStyle">
                        <v-row no-gutters style="height: 60px;">
                            <v-col cols="auto" align-self="center" class="px-2">
                                <v-btn icon @click="goBack">
                                    <v-img src="@/assets/icons/arrow-u-left-top.svg" max-width="36px" />
                                </v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto" align-self="center" class="px-2">
                                <span class="title-style logbook-title">Captain's Log - {{ formattedDate }}</span>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto" align-self="center" class="px-2">
                                <v-btn icon @click="showExtras = !showExtras" :disabled="showLoadingDialog">
                                    <v-img src="@/assets/icons/dots-vertical.svg" max-width="36px" />
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-row>

                <div class="logbook-map-wrap">
                    <div class="map logbook-map" ref="map"></div>
                </div>

                <!--<LoadingDialog v-model="showLoadingDialog"
                               message="GENERATING ..." />-->

                <ShareDialog v-model="showShareDialog"
                             :model="{ headline: 'Ready to share', text: '', imageUrl: shareImageUrl}"
                             @OnShare="shareNow"
                             @OnCancel="showShareDialog = false">
                    </ShareDialog>

                <div class="logoOnTop">
                    <v-img contain
                           position="top center"
                           max-height="56px"
                           max-width="200px"
                           src="/img/logo.png">
                    </v-img>
                </div>
            </v-col>
        </v-row>

        <div class="compassOnTop">
            <v-img contain
                   max-height="45px"
                   max-width="45px"
                   width="45px"
                   height="45px"
                   src="@/assets/icons/compass.svg">
            </v-img>
        </div>

        <div class="switchOnTop" @click="showCarousel = !showCarousel">
            <v-img v-if="showCarousel" src="@/assets/icons/view-sequential.svg" max-width="45px" max-height="45px" width="45px" height="45px" />
            <v-img v-else src="@/assets/icons/view-carousel-outline.svg" max-width="45px" max-height="45px" width="45px" height="45px" />
        </div>

        <div class="hintOnTop" @click="showHint = !showHint">
            <v-img contain
                   max-height="35px"
                   max-width="35px"
                   width="35px"
                   height="35px"
                   src="@/assets/icons/info-circle.svg">
            </v-img>
        </div>

        <v-carousel v-if="showCarousel" v-model="carouselModel" continuous cycle dark interval="3000" hide-delimiters hide-delimiter-background height="56px" class="dataCarousel" :show-arrows="false">
            <v-carousel-item v-for="(data, i) in tripData" :key="i">
                <v-sheet color="transparent" tile height="100%" @click="showCarousel = !showCarousel">
                    <div class="d-flex align-center justify-center py-1">
                        <v-img :src="getIconPath(data.icon)" class="mr-2" max-width="18px" width="18px" max-height="18px" height="18px" />
                        <span class="screenshot-style">{{ data.label }}: {{ data.value }} {{ data.unit }}</span>
                    </div>
                </v-sheet>
            </v-carousel-item>
        </v-carousel>
        <v-sheet v-else color="transparent" tile class="dataSheetAutoHeight ml-0" @click="showCarousel = !showCarousel">
            <div v-for="(data, i) in tripData" :key="i" align="left" class="py-1 pl-2">
                <div class="d-flex align-center">
                    <v-img :src="getIconPath(data.icon)" class="mr-2" max-width="18px" width="18px" max-height="18px" height="18px" />
                    <span class="screenshot-style">{{ data.label }}: {{ data.value }} {{ data.unit }}</span>
                </div>
            </div>
        </v-sheet>

        <v-dialog v-model="showExtras"
                  scrollable
                  height="600"
                  style="top: -200px">
            <v-card style="background-color: var(--app-color-surface);" :loading="showLoadingDialog">
                <template slot="progress">
                    <v-progress-linear color="secondary"
                                       height="8"
                                       indeterminate></v-progress-linear>
                </template>
                <v-card-title>
                    <span class="headline">Extra options</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pb-0 px-6">
                    <v-list :disabled="showLoadingDialog">
                        <v-list-item @click="captureAndShareBase(false)">
                            <v-list-item-icon>
                                <v-icon>mdi-share-variant-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Share captain's log</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="isFavourite" @click="captureAndShareBase(true)">
                            <v-list-item-icon>
                                <v-icon>mdi-share-variant-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Share log with journey memories</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="isFavourite && isCaptain" @click="showEditNicknameDialog = true">
                            <v-list-item-icon>
                                <v-icon>mdi-pencil-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Edit favourite journey</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="isFavourite && isCaptain" @click="showDeleteDialog = true">
                            <v-list-item-icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Delete favourite journey</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="!isFavourite && isCaptain" @click="showSaveDialog = true">
                            <v-list-item-icon>
                                <v-icon>mdi-content-save-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Save to favourites</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="isFavourite && (hasGalleryAccess || isCaptain)" @click.stop="goToGallery">
                            <v-list-item-icon>
                                <v-icon>mdi-panorama-variant-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Journey memories</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-row>
                        <v-col cols="12" class="text-center px-0 py-4">
                            <v-btn color="error"
                                   @click="showExtras = !showExtras">
                                RETURN
                                <v-icon right>
                                    mdi-arrow-u-left-top
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showSaveDialog"
                  width="85%"
                  persistent
                  scrollable
                  height="500"
                  style="top: -200px">
            <v-card style="background-color: var(--app-color-surface);">
                <v-card-title>
                    <span class="headline">Save journey as favourite</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-text-field v-model="nickname"
                                  label="Journey nickname"
                                  required
                                  :counter="30">
                    </v-text-field>
                    <v-text-field v-model="description"
                                  label="Journey description"
                                  :counter="40">
                    </v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-row>
                        <v-col cols="6" class="text-left pl-6 py-4">
                            <v-btn text color="primary"
                                   @click="showSaveDialog = !showSaveDialog">
                                RETURN
                                <v-icon right>
                                    mdi-arrow-u-left-top
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="text-right pr-6 py-4">
                            <v-btn color="primary"
                                   @click="saveJourney">
                                SAVE
                                <v-icon right>
                                    mdi-check
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showDeleteDialog"
                  width="85%"
                  persistent
                  scrollable
                  height="500"
                  style="top: -200px">
            <v-card style="background-color: var(--app-color-surface);">
                <v-card-title>
                    <span class="headline">Remove journey from favourites</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="px-6 py-4 text-center">
                    Are you sure you want to remove this journey from your favourites?
                    This action will also remove all the photos from the gallery!
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-row>
                        <v-col cols="6" class="text-left pl-6 py-4">
                            <v-btn text color="primary"
                                   @click="showDeleteDialog = !showDeleteDialog">
                                RETURN
                                <v-icon right>
                                    mdi-arrow-u-left-top
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="text-right pr-6 py-4">
                            <v-btn color="error"
                                   @click="deleteJourney">
                                REMOVE
                                <v-icon right>
                                    mdi-delete
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showEditNicknameDialog"
                  width="85%"
                  persistent
                  scrollable
                  height="500"
                  style="top: -200px">
            <v-card style="background-color: var(--app-color-surface);">
                <v-card-title>
                    <span class="headline">Edit journey</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-text-field v-model="journey.nickname"
                                  label="Journey nickname"
                                  required
                                  :counter="30">
                    </v-text-field>
                    <v-text-field v-model="journey.description"
                                  label="Journey description"
                                  :counter="40">
                    </v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-row>
                        <v-col cols="6" class="text-left pl-6 py-4">
                            <v-btn text color="primary"
                                   @click="showEditNicknameDialog = !showEditNicknameDialog">
                                RETURN
                                <v-icon right>
                                    mdi-arrow-u-left-top
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="text-right pr-6 py-4">
                            <v-btn color="primary"
                                   @click="updateJourney">
                                SAVE
                                <v-icon right>
                                    mdi-check
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showHint"
                  width="95%"
                  max-width="400px"
                  scrollable
                  height="600px"
                  style="top: -200px">
            <v-card style="background-color: var(--app-color-surface);">
                <v-card-title>
                    <span class="headline">Captain's Log Hints</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 400px;">
                    <v-list>
                        <v-list-item v-for="(item, i) in hintItems" :key="i">
                            <v-list-item-avatar>
                                <v-img contain :src="getIconPath(item.icon)" style="height: 40px;" />
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-text="item.text"></v-list-item-title>
                                <v-list-item-subtitle v-if="item.subtext" v-text="item.subtext"></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-row>
                        <v-col cols="12" class="text-center px-0 py-4">
                            <v-btn text color="primary"
                                   @click="showHint = !showHint">
                                RETURN
                                <v-icon right>
                                    mdi-arrow-u-left-top
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script lang="ts">
    import {
        defineComponent,
        getCurrentInstance,
        ref,
        computed,
        onMounted,
        watch,
    } from "vue";
    import { profile as profilestore } from "@/store/index";
    import { alarm, app } from "@/store";
    import parseISO from "date-fns/esm/fp/parseISO/index";
    import useLogbook from "@/store/useLogbook";
    import useMap from "@/utilities/useGoogleMaps";
    import { domToPng, domToBlob } from 'modern-screenshot'
    import moment from "moment-timezone";
    import useUserSettings from "@/store/useUserSettings";
    import useFavouriteJourney from "@/store/useFavouriteJourney";
    import FavouriteJourneyViewModel from "../models/FavouriteJourneyViewModel";
    import ProfileViewModel from "@/models/ProfileViewModel";
    import { deleteImageFromBlobStorage, downloadImageFromBlobStorage, uploadImageToBlobStorage, deleteImagesStartingWith } from "../store/useUserPictureStorage";
    import { ca } from "date-fns/locale";

    export default defineComponent({
        name: "LogbookRecord",
        components: {
            ConfirmDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/ConfirmDialog.vue"),
            ShareDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/ShareDialog.vue"),
            LoadingDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/LoadingDialog.vue"),
        },

        setup(props) {
            const root = getCurrentInstance()?.proxy as any;
            // Constants
            const CANVAS_WIDTH = 1535;
            const START_HEIGHT = 320;
            const HORIZONTAL_GAP = 100;
            const VERTICAL_GAP = 50;
            const LARGE_VERTICAL_GAP = VERTICAL_GAP * 2;
            const BORDER_WIDTH = 5;
            const ELEMENT_COLOR = 'white';
            const IMAGE_FORMAT = 'image/jpeg';
            const SHARE_FILE_NAME = 'MarineOne.jpg';
            const LOGO_IMAGE_PATH = '/img/logo.png';
            const BACKGROUND_IMAGE_PATH = 'img/background_long.jpg';
            const GOOGLE_MAP_ID = process.env.VUE_APP_GOOGLE_MAPS_MAP_ID || 'DEMO_MAP_ID';
            const TITLE = "Captain's Log";

            const { getUserSettings } = useUserSettings();
            const userTimezone = ref<string>(Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC");
            // UTC -> user's TZ -> YYYY-MM-DD
            const localYMD = (utcIso: string, tz: string) => moment.utc(utcIso).tz(tz).format("YYYY-MM-DD");

            const profile = computed<ProfileViewModel>(() => {
                return profilestore.profile;
            });

            const { getFavouriteJourney, updateFavouriteJourney, saveFavouriteJourney, deleteFavouriteJourney } = useFavouriteJourney();

            const hasGalleryAccess = computed<boolean>(() => {
                return profile.value ? profile.value.hasGalleryAccess : false;
            });

            const isCaptain = computed<boolean>(() => {
                return profile.value ? profile.value.isCaptain : false;
            });

            // Get the selected date from the route parameters (LOCAL date string, e.g. "YYYY-MM-DD").
            const selectedLocalDate = computed(() => String(root.$route.params.date));

            // Compute wide UTC window: (selectedLocal -1 day) .. (selectedLocal +2 days)
            const fetchStartUTC = computed(() =>
                moment.tz(selectedLocalDate.value, userTimezone.value).subtract(1, "day").format("YYYY-MM-DD")
            );
            const fetchEndUTC = computed(() =>
                moment.tz(selectedLocalDate.value, userTimezone.value).add(2, "day").format("YYYY-MM-DD")
            );

            // useLogbook expects "start,end"
            const selectedDateRange = computed(() => `${fetchStartUTC.value},${fetchEndUTC.value}`);

            const journeyId = root.$route.params.journeyId;

            // Get the logbook item from the route parameters.
            const isFavourite = computed(() => {
                return root.$route.params.isFavourite;
            });

            const journey = ref(new FavouriteJourneyViewModel());

            const { googleMapApi } = useMap();
            const map = ref();
            type AdvancedMarker = google.maps.marker.AdvancedMarkerElement;
            type ManagedAdvancedMarker = AdvancedMarker & { __gmpClickHandler?: EventListener };
            type ImageMarkerConfig = {
                url: string;
                width: number;
                height: number;
                alt: string;
            };
            let myGoogleMap: google.maps.Map;
            let poly: google.maps.Polyline;
            let shipMarker: AdvancedMarker;
            let startMarker: AdvancedMarker;
            let endMarker: AdvancedMarker;
            let ship: google.maps.LatLng;
            let startIcon: ImageMarkerConfig;
            let endIcon: ImageMarkerConfig;
            let roundTripIcon: ImageMarkerConfig;
            let maxSpeedIcon: ImageMarkerConfig;
            let onMountedFinished = false;
            let logbookItemsFetched = false;
            const showCarousel = ref(false);
            const totalTime = ref("");
            const startTime = ref("");
            const stopTime = ref("");
            const totalDistance = ref("");
            const averageSpeed = ref("");
            const roundTripRadius = 10; // 10 meters radius determining if the trip is a round trip or not.
            const maxSpeed = ref("");
            let maxSpeedIndex = 0;
            let carouselModel = ref(0);
            const showLoadingDialog = ref(false);
            const showEditNicknameDialog = ref(false);
            const showSaveDialog = ref(false);
            const showDeleteDialog = ref(false);
            const showShareDialog = ref(false);
            const infoWindows: google.maps.InfoWindow[] = [];
            const transientMarkers: AdvancedMarker[] = [];
            const showHint = ref(false);
            const showExtras = ref(false);
            const nickname = ref("");
            const description = ref("");
            let file: File;
            const uploadFile = ref<File | null>(null);
            let logFileName: string;
            const shareImageUrl = ref("");

            const goToGallery = async () => {
                logFileName = generateRandomFileName();
                // Wait for captureLog to complete
                try {
                    await captureLog();

                    if (uploadFile && uploadFile.value) {
                        await deleteImagesStartingWith("temp_" + profile.value.userId);
                        await uploadImageToBlobStorage(logFileName, new Uint8Array(await uploadFile.value.arrayBuffer()));
                    } else {
                        console.error("uploadFile or uploadFile.value is null");
                    }
                } catch (error) {
                    console.error("An error occurred:", error);
                }
                showLoadingDialog.value = false;
                root.$router.push({ name: "userGallery", params: { ids: journeyId, deviceId: profile.value.deviceId, logFile: logFileName } });
            };

            const saveJourney = () => {

                let model = new FavouriteJourneyViewModel();
                model.favouriteDate = selectedLocalDate.value;
                model.nickname = nickname.value;
                model.description = description.value;
                journey.value = model;
                saveFavouriteJourney(model);
                showExtras.value = false;
                showSaveDialog.value = false;
                app.success = "Journey saved successfully";
            };

            const updateJourney = () => {
                updateFavouriteJourney(journey.value);
                showExtras.value = false;
                showEditNicknameDialog.value = false;
            };

            const deleteJourney = async () => {

                const filenames = [journey.value.image1, journey.value.image2, journey.value.image3, journey.value.image4, journey.value.image5]

                for (let filename of filenames) {
                    if (filename) {
                        console.log("LogbookRecord: deleteJourney: deleting filename: " + filename);
                        await deleteImageFromBlobStorage(filename);
                    }
                }
                deleteFavouriteJourney(parseInt(journeyId));
                showExtras.value = false;
                showDeleteDialog.value = false;
                app.success = "Journey removed from favourites successfully";
                root.$router.push({ name: "settings" });
            };

            const captureLog = (): Promise<void> => {
                return new Promise((resolve, reject) => {
                    // user intent is clear, start conversion process
                    showLoadingDialog.value = true;

                    domToBlob(document.querySelector('#logContainer'), { type: 'image/jpeg', scale: 5 })
                        .then(blob => {
                            // Create an Image object from the blob
                            const img = new Image();
                            const crop = 570; // 300 pixels to crop from top bar and 270 pixels to crop from the map to hide logo and map/satellite options
                            img.onload = () => {
                                // Create a canvas to draw the cropped image
                                const canvas = document.createElement('canvas');
                                const ctx = canvas.getContext('2d');
                                canvas.width = img.width;
                                canvas.height = img.height - crop;

                                // Draw the image starting after the crop
                                ctx.drawImage(img, 0, - crop);

                                // Convert the canvas back to a blob
                                canvas.toBlob(croppedBlob => {
                                    uploadFile.value = new File([croppedBlob], logFileName, { type: 'image/jpeg' });
                                    resolve(); // Signal that the uploadFile.value is set
                                }, 'image/jpeg');
                            };

                            img.src = URL.createObjectURL(blob);
                        })
                        .catch(error => {
                            reject(error); // handle the error
                        });
                });
            };

            // Helper function to load an image
            const loadImage = (src: string): Promise<HTMLImageElement> => {
                return new Promise<HTMLImageElement>((resolve, reject) => {
                    const img = new Image();
                    img.onload = () => resolve(img);
                    img.onerror = reject;
                    img.src = src;
                });
            };

            // Helper function to download and prepare images
            const downloadAndPrepareImages = async (filenames) => {
                const imageList = [];
                for (let filename of filenames) {
                    if (filename) {
                        const imageData = await downloadImageFromBlobStorage(filename);
                        const blob = new Blob([imageData], { type: IMAGE_FORMAT });
                        const url = URL.createObjectURL(blob);
                        const img = await loadImage(url);
                        imageList.push(img);
                    }
                }
                return imageList;
            };

            // Helper function to calculate the total height of the canvas
            const calculateTotalHeight = (logImage: HTMLImageElement, imageList?: HTMLImageElement[]): number => {
                let totalHeight = 0;

                // Add the starting height
                totalHeight += START_HEIGHT;

                // Calculate logImage height
                const logHeight = (CANVAS_WIDTH - 2 * (HORIZONTAL_GAP + BORDER_WIDTH)) * logImage.height / logImage.width;
                totalHeight += logHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;

                if (imageList) {
                    // Calculate height for each image in the list if included
                    for (let image of imageList) {
                        const scaledWidth = CANVAS_WIDTH - 2 * (HORIZONTAL_GAP + BORDER_WIDTH);
                        const scaledHeight = scaledWidth * image.height / image.width;
                        totalHeight += scaledHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;
                    }
                }

                // Add a LARGE_VERTICAL_GAP after last image and subtract overflow (calculated manually)
                totalHeight += LARGE_VERTICAL_GAP - 32;

                return totalHeight;
            };

            const captureAndShareBase = async (includeGallery = false) => {
                try {
                    showLoadingDialog.value = true;

                    await captureLog();

                    const logoImg: HTMLImageElement = await loadImage(LOGO_IMAGE_PATH);
                    const background: HTMLImageElement = await loadImage(BACKGROUND_IMAGE_PATH);
                    const logImage: HTMLImageElement = new Image();

                    if (uploadFile && uploadFile.value) {
                        const logUrl = URL.createObjectURL(uploadFile.value);
                        logImage.src = logUrl;
                        await new Promise(resolve => logImage.onload = resolve);

                        // Load the gallery images if required
                        let imageList: HTMLImageElement[] = [];

                        if (includeGallery) {
                            // Fetch journey images
                            const filenames = [
                                journey.value.image1,
                                journey.value.image2,
                                journey.value.image3,
                                journey.value.image4,
                                journey.value.image5
                            ];

                            if (filenames.length > 0) {
                                imageList = await downloadAndPrepareImages(filenames);
                            }
                        }

                        // Create canvas and its context
                        const canvas = document.createElement('canvas');
                        canvas.width = CANVAS_WIDTH;
                        canvas.height = calculateTotalHeight(logImage, imageList);
                        const ctx = canvas.getContext('2d');

                        // Draw the background
                        ctx.drawImage(background, 0, 0, CANVAS_WIDTH, canvas.height);

                        // Draw the logo
                        ctx.drawImage(logoImg, HORIZONTAL_GAP, VERTICAL_GAP, logoImg.width / 2, logoImg.height / 2);

                        // The position where the logo starts vertically (top-most point)
                        const logoStartY = VERTICAL_GAP;

                        // The height of the logo after scaling
                        const scaledLogoHeight = (logoImg.width / 2) * logoImg.height / logoImg.width;

                        // Calculate mid-points for title and date relative to the logo's vertical position
                        const titleMidPoint = logoStartY + (scaledLogoHeight / 2);  // Half of the upper half
                        const dateMidPoint = logoStartY + scaledLogoHeight - 32;  // Half of the lower half

                        // Draw the title
                        ctx.font = "78px Arial"; // change to Open sans
                        ctx.fillStyle = ELEMENT_COLOR;
                        ctx.textAlign = "center";
                        const titleX = (canvas.width / 2) + (canvas.width / 5);
                        ctx.fillText(TITLE, titleX, titleMidPoint);

                        // Draw the date
                        const date = formattedDate.value;
                        ctx.font = "55px Arial";
                        ctx.fillStyle = ELEMENT_COLOR;
                        const dateX = (canvas.width / 2) + (canvas.width / 5);
                        ctx.fillText(date, dateX, dateMidPoint);

                        // Starting Y position for journey images
                        let currentY = logoStartY + scaledLogoHeight + VERTICAL_GAP;

                        // Draw log
                        const logHeight = (canvas.width - 2 * (HORIZONTAL_GAP + BORDER_WIDTH)) * logImage.height / logImage.width;
                        const logWidth = canvas.width - 2 * (HORIZONTAL_GAP + BORDER_WIDTH);

                        // Create the white border
                        ctx.fillStyle = ELEMENT_COLOR;
                        ctx.fillRect(
                            HORIZONTAL_GAP - BORDER_WIDTH,
                            currentY - BORDER_WIDTH,
                            logWidth + 2 * BORDER_WIDTH,
                            logHeight + 2 * BORDER_WIDTH
                        );

                        // Draw the log image inside the white border
                        ctx.drawImage(logImage, HORIZONTAL_GAP, currentY, logWidth, logHeight);

                        // Adjust currentY for subsequent images
                        currentY += logHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;

                        // Optionally draw the gallery images
                        if (includeGallery && imageList.length > 0) {

                            for (let image of imageList) {
                                const scaledWidth = canvas.width - 2 * HORIZONTAL_GAP;
                                const scaledHeight = scaledWidth * image.height / image.width;

                                // Draw the white border/background
                                ctx.fillStyle = ELEMENT_COLOR;
                                ctx.fillRect(HORIZONTAL_GAP - BORDER_WIDTH, currentY - BORDER_WIDTH, scaledWidth + 2 * BORDER_WIDTH, scaledHeight + 2 * BORDER_WIDTH);

                                // Draw the image on top of the white background
                                ctx.drawImage(image, HORIZONTAL_GAP, currentY, scaledWidth, scaledHeight);

                                // Move to the position for the next image
                                currentY += scaledHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;
                            }

                        }
                        // Handle the final image
                        canvas.toBlob(croppedBlob => {
                            file = new File([croppedBlob], SHARE_FILE_NAME, { type: IMAGE_FORMAT });
                            showLoadingDialog.value = false;
                            shareImageUrl.value = URL.createObjectURL(file);
                            showShareDialog.value = true;
                            URL.revokeObjectURL(logUrl);
                        }, IMAGE_FORMAT);

                        // Hide loading dialog
                        showLoadingDialog.value = false;

                    } else {
                        app.error = "Image creation failed";
                        showLoadingDialog.value = false;
                    }

                } catch (err) {
                    showLoadingDialog.value = false;
                    app.error = "An error occurred while generating the image: " + err;
                    console.error("An error occurred:", err);
                }
            };

            const shareNow = () => {
                // only display the loading dialog if sharing is possible
                if ((navigator as any).canShare && (navigator as any).canShare({ files: [file] })) {

                    const shareData: any = {
                        files: [file],
                        title: 'MarineOne Logbook',
                        text: 'MarineOne logbook entry from ' + formattedDate.value,
                    };

                    (navigator as any).share(shareData)
                        .then(() => {
                            console.log('Sharing successful.');
                        })
                        .catch((error: any) => {
                            app.error = error;
                        });
                } else {
                    app.error = `Your device doesn't support sharing files.`;
                }
            }

            const getIconPath = (icon) => {
                return require(`@/assets/icons/${icon}.svg`);
            };

            const tripData = ref([
                { label: 'Start Time', value: '00:00', unit: '', icon: 'timer-play-outline' },
                { label: 'Stop Time', value: '00:00', unit: '', icon: 'timer-stop-outline' },
                { label: 'Trip Time', value: '0s', unit: '', icon: 'timer-sync-outline' },
                { label: 'Trip Distance', value: '0.00', unit: 'NM', icon: 'map-marker-distance' },
                { label: 'Average Speed', value: '0.00', unit: 'kts', icon: 'speedometer-medium' },
                { label: 'Max Speed', value: '0.00', unit: 'kts', icon: 'speedometer' }
            ]);

            const menuItems = ref([
                { icon: 'mdi-share-variant-outline', text: 'Share Trip', value: 'share' },
                { icon: 'mdi-check', text: 'Show All Trip Info', value: 'show-all' },
            ]);

            const hintItems = ref([
                { icon: 'view-carousel-outline-blk', text: 'Cycle trip info', subtext: '' },
                { icon: 'view-sequential-blk', text: 'View all trip info' },
                { icon: 'share-variant-outline-blk', text: 'Share trip as a screenshot' },
                { icon: 'compass', text: 'North indicator' },
                { icon: 'map-position-dot', text: 'Position dot', subtext: 'Click: Info bubble with time and GPS' },
                { icon: 'map-arrow', text: 'Boat heading indicator', subtext: 'Click: Info bubble with heading' },
                { icon: 'map-marker-round-trip', text: 'Round trip indicator', subtext: 'Click: Info bubble with time and GPS' },
                { icon: 'map-marker-start', text: 'Start trip location', subtext: 'Click: Info bubble with time and GPS' },
                { icon: 'map-marker-stop', text: 'Finish trip location', subtext: 'Click: Info bubble with time and GPS' },
                { icon: 'max-speed', text: 'Section with maximum speed', subtext: 'Click: Info bubble with max speed' },
                { icon: 'info-circle-blk', text: 'Click map anywhere to close bubbles' },
            ]);

            // Create a return function to go back to the settings page.
            const goBack = () => {
                root.$router.push({ name: "settings" });
            };

            // Create a latitude and longitude object from the alarm's latitude and longitude values.
            const lat = computed<number>(() => { return alarm.lat ? alarm.lat : 0; });
            const lng = computed<number>(() => { return alarm.lng ? alarm.lng : 0; });

            const formattedDate = computed<string>(() => {
                const date = new Date(selectedLocalDate.value);
                const day = date.getDate();
                const month = date.toLocaleString('en-US', { month: 'long' });
                const year = date.getFullYear();

                let daySuffix = 'th';
                if (day === 1 || day === 21 || day === 31) {
                    daySuffix = 'st';
                } else if (day === 2 || day === 22) {
                    daySuffix = 'nd';
                } else if (day === 3 || day === 23) {
                    daySuffix = 'rd';
                }

                return `${day}${daySuffix} of ${month}, ${year}`;
            });

            // Create a start date and end date for the selected date.
            const startDate = computed(() => {
                const currentDate = parseISO(selectedLocalDate.value);
                return new Date(currentDate.getTime() - currentDate.getTimezoneOffset() * 60000
                ).toISOString().substring(0, 10);
            });

            const endDate = computed(() => {
                const startDateValue = new Date(startDate.value);
                const endDateValue = new Date(startDateValue.getTime() + 1 * 24 * 60 * 60 * 1000);
                return endDateValue.toISOString().substring(0, 10);
            });

            // Get the logbook items for the widened UTC date range.
            const { logbookItems } = useLogbook(selectedDateRange.value);

            // Items that belong to the selected LOCAL day (filtered by user TZ).
            const dayItems = computed(() =>
                (logbookItems.value ?? [])
                    .filter(it => localYMD(it.gpsTimestamp, userTimezone.value) === selectedLocalDate.value)
                    // Index 0 is newest, last index is oldest, thus the start of journey. Sort by gpsTimestamp ascending to ensure this.
                    .sort((a, b) => parseISO(b.gpsTimestamp).getTime() - parseISO(a.gpsTimestamp).getTime())
            );

            // === Add: Local time formatter + pretty InfoWindow card ===
            // UTC -> user's TZ -> formatted string
            const formatLocalTZ = (utcIso: string, fmt = "YYYY-MM-DD HH:mm:ss z") =>
                moment.utc(utcIso).tz(userTimezone.value).format(fmt);

            // Return a typed row only if condition is true
            const rowIf = (cond: boolean, row: [string, string | number]) =>
                (cond ? [row] as Array<[string, string | number]> : ([] as Array<[string, string | number]>));

            // Small HTML card to make InfoWindows look nice
            const infoCard = (title: string, rows: Array<[string, string | number]>) => `
              <div style="
                font-family: system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
                color:#fff; background:#0b132b; border-radius:14px;
                width:100%; min-width:0; max-width:340px; box-sizing:border-box; overflow:hidden;">
                <div style="padding:10px 36px 10px 12px; font-weight:600; font-size:var(--app-font-body);">
                  ${title}
                </div>
                <div style="padding:10px 12px; background:rgba(255,255,255,.04)">
                  ${rows.map(([k, v]) => `
                    <div style="display:flex; justify-content:space-between; gap:12px; padding:6px 0; border-bottom:1px solid rgba(255,255,255,.08)">
                      <div style="opacity:.8">${k}</div>
                      <div style="font-weight:600">${v}</div>
                    </div>
                  `).join("")}
                </div>
              </div>
            `;

            const createImageMarkerContent = (icon: ImageMarkerConfig): HTMLDivElement => {
                const wrapper = document.createElement("div");
                wrapper.style.width = `${icon.width}px`;
                wrapper.style.height = `${icon.height}px`;
                wrapper.style.display = "flex";
                wrapper.style.alignItems = "center";
                wrapper.style.justifyContent = "center";

                const img = document.createElement("img");
                img.src = icon.url;
                img.alt = icon.alt;
                img.width = icon.width;
                img.height = icon.height;
                img.draggable = false;
                img.style.width = "100%";
                img.style.height = "100%";
                img.style.objectFit = "contain";
                img.style.userSelect = "none";
                img.style.pointerEvents = "none";

                wrapper.appendChild(img);
                return wrapper;
            };

            const createHistoryMarkerContent = (): HTMLDivElement => {
                const dot = document.createElement("div");
                dot.style.width = "8px";
                dot.style.height = "8px";
                dot.style.borderRadius = "50%";
                dot.style.backgroundColor = "#a6a6a6";
                dot.style.border = "1px solid #a6a6a6";
                dot.style.boxSizing = "border-box";
                dot.style.pointerEvents = "none";
                return dot;
            };

            const createHeadingMarkerContent = (heading: number): HTMLDivElement => {
                const wrapper = document.createElement("div");
                wrapper.style.width = "18px";
                wrapper.style.height = "18px";
                wrapper.style.display = "flex";
                wrapper.style.alignItems = "center";
                wrapper.style.justifyContent = "center";
                wrapper.style.transform = `rotate(${heading}deg)`;
                wrapper.style.transformOrigin = "center center";

                wrapper.innerHTML = `
                    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M9 1L16 17L9 13L2 17L9 1Z" fill="#48A6AD" stroke="#182551" stroke-width="1.4" stroke-linejoin="round" />
                    </svg>
                `;

                return wrapper;
            };

            const createAdvancedMarker = (options: {
                position: google.maps.LatLng | google.maps.LatLngLiteral;
                content: Node;
                title?: string;
                zIndex?: number;
                visible?: boolean;
                clickable?: boolean;
            }): AdvancedMarker => {
                return new google.maps.marker.AdvancedMarkerElement({
                    map: options.visible === false ? null : myGoogleMap,
                    position: options.position,
                    content: options.content,
                    title: options.title,
                    zIndex: options.zIndex,
                    gmpClickable: options.clickable ?? false,
                });
            };

            const openInfoWindowAtMarker = (infoWindow: google.maps.InfoWindow, marker: AdvancedMarker) => {
                clearInfoWindows();
                infoWindow.open({
                    map: myGoogleMap,
                    anchor: marker,
                    shouldFocus: false,
                });
            };

            const clearInfoWindows = () => {
                infoWindows.forEach(infoWindow => infoWindow.close());
                infoWindows.length = 0;
            };

            const clearTransientMarkers = () => {
                transientMarkers.forEach(marker => {
                    google.maps.event.clearInstanceListeners(marker);
                    marker.map = null;
                });
                transientMarkers.length = 0;
            };

            const setMarkerVisible = (marker: AdvancedMarker, visible: boolean) => {
                marker.map = visible ? myGoogleMap : null;
            };

            const setMarkerIcon = (marker: AdvancedMarker, icon: ImageMarkerConfig) => {
                marker.content = createImageMarkerContent(icon);
            };

            const setMarkerContentVisible = (marker: AdvancedMarker, visible: boolean) => {
                if (marker.content instanceof HTMLElement) {
                    marker.content.style.display = visible ? "flex" : "none";
                }
            };

            const setMarkerClickHandler = (marker: AdvancedMarker, handler: EventListener) => {
                const managedMarker = marker as ManagedAdvancedMarker;

                if (managedMarker.__gmpClickHandler) {
                    managedMarker.removeEventListener("gmp-click", managedMarker.__gmpClickHandler);
                }

                managedMarker.__gmpClickHandler = handler;
                managedMarker.addEventListener("gmp-click", handler);
            };

            const getMarkerPosition = (marker: AdvancedMarker): google.maps.LatLng => {
                if (marker.position instanceof google.maps.LatLng) {
                    return marker.position;
                }

                if (marker.position) {
                    return new google.maps.LatLng(marker.position.lat, marker.position.lng);
                }

                throw new Error("Marker position is not set.");
            };

            // Function to determine if marker2 is within the given radius of marker1
            function isMarkerWithinRadius(marker1: AdvancedMarker, marker2: AdvancedMarker, radius: number): boolean {
                const position1 = getMarkerPosition(marker1);
                const position2 = getMarkerPosition(marker2);
                const distance = google.maps.geometry.spherical.computeDistanceBetween(position1, position2);
                return distance <= radius;
            }

            // Function to calculate the speed between two points given their latitude, longitude, and timestamps
            function calculateSpeedInKnots(point1: google.maps.LatLng, time1: number, point2: google.maps.LatLng, time2: number): number {

                const distance = google.maps.geometry.spherical.computeDistanceBetween(point1, point2) / 1852; // Convert to nautical miles

                // Calculate the time difference in seconds
                const timeDiff = Math.abs(time2 - time1) / 1000;

                // Calculate the speed in knots
                let speed = distance / (timeDiff / 3600); // Convert to knots

                return speed;
            }

            function getClosestPointOnPolyline(point: google.maps.LatLng, polyline: google.maps.Polyline): google.maps.LatLng {
                const path = polyline.getPath();

                if (path.getLength() === 0) {
                    return point;
                }

                let closestPoint = path.getAt(0);
                let closestDistance = google.maps.geometry.spherical.computeDistanceBetween(point, closestPoint);
                const longitudeScale = Math.max(Math.abs(Math.cos(point.lat() * Math.PI / 180)), 0.000001);

                const project = (latLng: google.maps.LatLng) => ({
                    x: latLng.lng() * longitudeScale,
                    y: latLng.lat(),
                });

                const target = project(point);

                for (let i = 0; i < path.getLength() - 1; i++) {
                    const start = path.getAt(i);
                    const end = path.getAt(i + 1);
                    const projectedStart = project(start);
                    const projectedEnd = project(end);
                    const dx = projectedEnd.x - projectedStart.x;
                    const dy = projectedEnd.y - projectedStart.y;
                    const segmentLengthSquared = dx * dx + dy * dy;
                    const ratio = segmentLengthSquared === 0
                        ? 0
                        : Math.max(0, Math.min(1, ((target.x - projectedStart.x) * dx + (target.y - projectedStart.y) * dy) / segmentLengthSquared));
                    const candidate = new google.maps.LatLng(
                        projectedStart.y + ratio * dy,
                        (projectedStart.x + ratio * dx) / longitudeScale
                    );
                    const candidateDistance = google.maps.geometry.spherical.computeDistanceBetween(point, candidate);

                    if (candidateDistance < closestDistance) {
                        closestPoint = candidate;
                        closestDistance = candidateDistance;
                    }
                }

                return closestPoint;
            }

            // Function to find the maximum speed among sections of the polyline
            function findMaxSpeed(polyline: google.maps.Polyline): number {
                const path = polyline.getPath();

                let foundMaxSpeed = 0;

                for (let i = 1; i < path.getLength(); i++) {

                    const point1 = path.getAt(i - 1);
                    const point2 = path.getAt(i);

                    const time1 = parseISO(dayItems.value[i - 1].gpsTimestamp).getTime();
                    const time2 = parseISO(dayItems.value[i].gpsTimestamp).getTime();

                    const speed = calculateSpeedInKnots(point1, time1, point2, time2)

                    if (speed > foundMaxSpeed) {
                        foundMaxSpeed = speed;
                        maxSpeedIndex = i;
                    }
                }
                return foundMaxSpeed;
            }

            function formatTimestamp(timestamp) {
                const date = new Date(timestamp);
                const options: Intl.DateTimeFormatOptions = {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false
                };
                return date.toLocaleString("en-US", options) + " (UTC)";
            }

            function generateRandomFileName(length = 32): string {
                const userId = profile.value.userId;
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let result = '';
                for (let i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * characters.length));
                }
                return "temp_" + userId + "_" + result + '.jpeg';
            }

            // Loop through the logbook items and create a polyline, markers and calculate the total distance, total time and average speed.
            const runLoop = () => {
                // Operate on filtered items for the selected local day
                if (dayItems.value.length > 0) {

                    console.log("LogbookRecord: runLoop: dayItems length: " + dayItems.value.length);

                    clearInfoWindows();
                    clearTransientMarkers();
                    google.maps.event.clearInstanceListeners(startMarker);
                    google.maps.event.clearInstanceListeners(endMarker);
                    setMarkerVisible(startMarker, false);
                    setMarkerVisible(endMarker, false);
                    setMarkerIcon(startMarker, startIcon);

                    // Create a new empty polyline.
                    poly.getPath().clear();

                    dayItems.value.forEach((logbookItem, index) => {

                        // print gpsTimestamp, longitude, latitude, speed_kmh, accuracy and sourceTag
                        console.log(`LogbookRecord: runLoop: logbookItem ${index}: gpsTimestamp: ${logbookItem.gpsTimestamp}, latitude: ${logbookItem.latitude}, longitude: ${logbookItem.longitude}, speed_kmh: ${logbookItem.speed_kmh}, accuracy: ${logbookItem.accuracy}, sourceTag: ${logbookItem.sourceTag}`);

                        const pos = new google.maps.LatLng(logbookItem.latitude, logbookItem.longitude);
                        // Add a new point to the Polyline based on the logbook item's latitude and longitude.

                        // Create an object representing the point with custom properties
                        const point = {
                            position: pos,
                            gpsTimestamp: logbookItem.gpsTimestamp, // Custom property: GPS timestamp
                            accuracy: logbookItem.accuracy // Custom property: Accuracy
                        };

                        poly.getPath().push(point.position);

                        if (index === 0) {
                            // Set the end marker's position to the first point in the Polyline.
                            endMarker.position = pos;
                            setMarkerClickHandler(endMarker, () => {
                                // Create a new info window.
                                const infoWindow = new google.maps.InfoWindow({
                                    content: infoCard("End position", [
                                        ["Local time", formatLocalTZ(logbookItem.gpsTimestamp)],
                                        ["Latitude", logbookItem.latitude],
                                        ["Longitude", logbookItem.longitude],
                                        ...rowIf(typeof logbookItem.accuracy === "number", ["Accuracy (m)", logbookItem.accuracy]),
                                    ]),
                                });
                                // Open the info window.
                                openInfoWindowAtMarker(infoWindow, endMarker);
                                infoWindows.push(infoWindow);
                            });
                            setMarkerVisible(endMarker, true);
                        } else if (index === dayItems.value.length - 1) {
                            // Set the start marker's position to the last point in the Polyline.
                            startMarker.position = pos;
                            setMarkerClickHandler(startMarker, () => {
                                // Create a new info window.
                                const infoWindow = new google.maps.InfoWindow({
                                    content: infoCard("Start position", [
                                        ["Local time", formatLocalTZ(logbookItem.gpsTimestamp)],
                                        ["Latitude", logbookItem.latitude],
                                        ["Longitude", logbookItem.longitude],
                                        ...rowIf(typeof logbookItem.accuracy === "number", ["Accuracy (m)", logbookItem.accuracy]),
                                    ]),
                                });

                                // Open the info window.
                                openInfoWindowAtMarker(infoWindow, startMarker);
                                infoWindows.push(infoWindow);
                            });
                            setMarkerVisible(startMarker, true);
                        } else {
                            // Create a new marker for each point in the Polyline.
                            const historyMarker = createAdvancedMarker({
                                position: pos,
                                content: createHistoryMarkerContent(),
                                title: "Track point",
                                zIndex: 3,
                                clickable: true,
                            });
                            transientMarkers.push(historyMarker);
                            setMarkerClickHandler(historyMarker, () => {
                                // Create a new info window.
                                const infoWindow = new google.maps.InfoWindow({
                                    content: infoCard("Track point", [
                                        ["Local time", formatLocalTZ(logbookItem.gpsTimestamp)],
                                        ["Latitude", logbookItem.latitude],
                                        ["Longitude", logbookItem.longitude],
                                        ...rowIf(typeof logbookItem.accuracy === "number", ["Accuracy (m)", logbookItem.accuracy]),
                                        ...rowIf(typeof logbookItem.speed_kmh === "number", ["Speed", `${(logbookItem.speed_kmh / 1.852).toFixed(2)} kts`]),
                                    ]),
                                });
                                // Open the info window.
                                openInfoWindowAtMarker(infoWindow, historyMarker);
                                infoWindows.push(infoWindow);
                            });
                        }
                    });

                    // Calculate whether the end marker is within the radius of the start marker
                    const withinRadius = isMarkerWithinRadius(startMarker, endMarker, roundTripRadius);

                    // If the end marker is within the radius of the start marker, then it is a round trip
                    if (withinRadius) {
                        // Handle case where it is a round trip, as start and end markers are in a given radius from each other
                        setMarkerVisible(endMarker, false);
                        endMarker.position = getMarkerPosition(startMarker);
                        setMarkerIcon(startMarker, roundTripIcon);
                        poly.getPath().removeAt(poly.getPath().getLength() - 1);
                        poly.getPath().push(getMarkerPosition(startMarker));
                    } else {
                        // Handle case where it is not a round trip, as start and end markers are not in a given radius from each other
                        setMarkerVisible(endMarker, true);
                        setMarkerIcon(startMarker, startIcon);
                    }

                    maxSpeed.value = findMaxSpeed(poly).toFixed(2);

                    // Get the halfway point coordinates
                    const halfwayPoint = google.maps.geometry.spherical.interpolate(
                        poly.getPath().getAt(maxSpeedIndex),
                        poly.getPath().getAt(maxSpeedIndex + 1),
                        0.5
                    );

                    // Create a new marker for the halfway point.
                    const maxSpeedMarker = createAdvancedMarker({
                        position: halfwayPoint,
                        content: createImageMarkerContent(maxSpeedIcon),
                        title: "Max speed segment",
                        zIndex: 5,
                        clickable: true,
                    });
                    transientMarkers.push(maxSpeedMarker);

                    setMarkerClickHandler(maxSpeedMarker, () => {
                        // Create a new info window.
                        const a = dayItems.value[maxSpeedIndex];
                        const b = dayItems.value[maxSpeedIndex + 1];
                        const infoWindow = new google.maps.InfoWindow({
                            content: infoCard("Max speed segment", [
                                ["Max speed", `${maxSpeed.value} kts`],
                                ...rowIf(!!a, ["From", formatLocalTZ(a.gpsTimestamp)]),
                                ...rowIf(!!b, ["To", formatLocalTZ(b.gpsTimestamp)]),
                            ]),
                        });
                        // Open the info window.
                        openInfoWindowAtMarker(infoWindow, maxSpeedMarker);
                        infoWindows.push(infoWindow);
                    });

                    // Create a heading marker on each segment of the polyline
                    poly.getPath().forEach((point, index) => {
                        if (index < poly.getPath().getLength() - 1) {

                            // Get the halfway point coordinates between two points in the Polyline
                            const halfwayPoint = google.maps.geometry.spherical.interpolate(
                                poly.getPath().getAt(index + 1),
                                point,
                                0.5
                            );

                            // Snap halfway point to the polyline to ensure it is on the line
                            const snappedHalfwayPoint = google.maps.geometry.poly.isLocationOnEdge(halfwayPoint, poly, 0.0001)
                                ? halfwayPoint
                                : getClosestPointOnPolyline(halfwayPoint, poly);

                            // Calculate heading between two points and set the heading marker's rotation
                            const heading = google.maps.geometry.spherical.computeHeading(
                                poly.getPath().getAt(index + 1),
                                point
                            );

                            // Create a new marker for the halfway point.
                            const headingMarker = createAdvancedMarker({
                                position: snappedHalfwayPoint,
                                content: createHeadingMarkerContent(heading),
                                title: "Heading",
                                zIndex: 4,
                                clickable: true,
                            });
                            transientMarkers.push(headingMarker);

                            setMarkerClickHandler(headingMarker, () => {
                                // Create a new info window.
                                const pt = dayItems.value[index];
                                const infoWindow = new google.maps.InfoWindow({
                                    content: infoCard("Heading", [
                                        ["Direction", `${heading.toFixed(0)}&deg;`],
                                        ...rowIf(!!pt, ["Local time", formatLocalTZ(pt.gpsTimestamp)]),
                                    ]),
                                });
                                // Open the info window.
                                openInfoWindowAtMarker(infoWindow, headingMarker);
                                infoWindows.push(infoWindow);
                            });
                        }
                        console.log("Removing Google Fonts from runLoop()");
                        //    removeGoogleFontsForMaps();
                    });

                    // Create a new bounds object.
                    var bounds = new google.maps.LatLngBounds();
                    // Extend the bounds object with the polyline's path.
                    poly.getPath().forEach(function (e) { //can't do polyline.getPath()[i] because it's a MVCArray
                        bounds.extend(e);
                    })
                    // Fit the map to the bounds.
                    myGoogleMap.fitBounds(bounds);

                    // Use dayItems for timestamps,
                    // and display as user's LOCAL times (HH:mm)
                    let startTimestamp = dayItems.value[dayItems.value.length - 1].gpsTimestamp;
                    let stopTimestamp = dayItems.value[0].gpsTimestamp;

                    const startLocal = moment.utc(startTimestamp).tz(userTimezone.value);
                    const stopLocal = moment.utc(stopTimestamp).tz(userTimezone.value);

                    startTime.value = startLocal.format("HH:mm");
                    stopTime.value = stopLocal.format("HH:mm");

                    // Calculate the total time of the trip in milliseconds and convert it to days, hours, minutes and seconds.
                    const totalTimeInMs = parseISO(stopTimestamp).getTime() - parseISO(startTimestamp).getTime();

                    // Time calculations for days, hours, minutes and seconds
                    const totalTimeInSeconds = Math.floor(totalTimeInMs / 1000);
                    const days = Math.floor(totalTimeInMs / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((totalTimeInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((totalTimeInMs % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((totalTimeInMs % (1000 * 60)) / 1000);

                    // Output the result in an element with id="demo"
                    let timestring = "";
                    timestring = days > 0 ? `${timestring}${days}d ` : "";
                    timestring = hours > 0 ? `${timestring}${hours}h ` : "";
                    timestring = minutes > 0 ? `${timestring}${minutes}m ` : "";
                    timestring = seconds > 0 ? `${timestring}${seconds}s` : "0s";

                    // Display the result
                    totalTime.value = timestring.trim();

                    // Calculate distance of the polyline
                    let distance = google.maps.geometry.spherical.computeLength(poly.getPath().getArray()) / 1852; // Convert to nautical miles

                    // Display the result
                    if (distance) {
                        totalDistance.value = distance.toFixed(2);
                    } else {
                        totalDistance.value = "0.00";
                    }

                    // Calculate average speed and display the result
                    let averageSpeedKTS = distance / (totalTimeInSeconds / 3600); // Convert to knots

                    // Display the result
                    averageSpeed.value = averageSpeedKTS.toFixed(2);

                    tripData.value = [
                        { label: 'Start Time', value: startTime.value, unit: '', icon: 'timer-play-outline' },
                        { label: 'Stop Time', value: stopTime.value, unit: '', icon: 'timer-stop-outline' },
                        { label: 'Trip Time', value: totalTime.value, unit: '', icon: 'timer-sync-outline' },
                        { label: 'Trip Distance', value: totalDistance.value, unit: 'NM', icon: 'map-marker-distance' },
                        { label: 'Average Speed', value: averageSpeed.value, unit: 'kts', icon: 'speedometer-medium' },
                        { label: 'Max Speed', value: maxSpeed.value, unit: 'kts', icon: 'speedometer' }
                    ];
                }
            }

            onMounted(async () => {

                if (!isNaN(parseInt(journeyId))) {
                    journey.value = await getFavouriteJourney(parseInt(journeyId));
                }

                await profilestore.Get();
                try {
                    const us = await getUserSettings();
                    if (us?.timezone) userTimezone.value = us.timezone;
                } catch { /* keep fallback */ }
                // Load the Google Maps API and create the map, polyline and ship marker.
                googleMapApi.load().then(() => {
                    // Create a latitude and longitude object from the alarm's latitude and longitude values.
                    ship = new google.maps.LatLng(lat.value, lng.value);

                    // Create an icon for the markers.
                    const shipIcon: ImageMarkerConfig = {
                        url: '/img/icons/map-marker-device.svg',
                        width: 80,
                        height: 80,
                        alt: 'Ship marker',
                    };

                    startIcon = {
                        url: '/img/icons/map-marker-start.svg',
                        width: 80,
                        height: 80,
                        alt: 'Start marker',
                    };

                    endIcon = {
                        url: '/img/icons/map-marker-stop.svg',
                        width: 80,
                        height: 80,
                        alt: 'End marker',
                    };

                    roundTripIcon = {
                        url: '/img/icons/map-marker-round-trip.svg',
                        width: 80,
                        height: 80,
                        alt: 'Round trip marker',
                    };

                    maxSpeedIcon = {
                        url: '/img/icons/max-speed.svg',
                        width: 40,
                        height: 40,
                        alt: 'Max speed marker',
                    };

                    // Create the map.
                    myGoogleMap = new google.maps.Map(map.value, {
                        center: ship,
                        mapTypeId: "satellite",
                        zoom: 16,
                        disableDefaultUI: true,
                        zoomControl: false,
                        backgroundColor: "#000000",
                        mapTypeControl: true,
                        mapTypeControlOptions: {
                            style: google.maps.MapTypeControlStyle.DEFAULT,
                            mapTypeIds: ["roadmap", "satellite"],
                        },
                        mapId: GOOGLE_MAP_ID,
                        fullscreenControl: false
                    });

                    myGoogleMap.addListener("click", () => {
                        clearInfoWindows();
                    });

                    // Only show headings when zoomed in enough, otherwise they clutter the map
                    myGoogleMap.addListener("zoom_changed", () => {
                        // Access the inner map zoom depth property
                        const zoomLevel = myGoogleMap.getZoom();
                        console.log("B Zoom level changed to: " + zoomLevel);

                        if (zoomLevel === undefined) {
                            console.warn("Zoom level is undefined. Skipping marker visibility update.");
                            return;
                        }

                        // Filter form markers with title "Track point" and "Heading" to avoid affecting other markers
                        transientMarkers.forEach(marker => {
                            if (marker.title === "Heading" || marker.title === "Track point") {
                                setMarkerContentVisible(marker, zoomLevel >= 15);
                            }
                        });
                    });

                    // Create the ship marker.
                    shipMarker = createAdvancedMarker({
                        position: ship,
                        visible: false,
                        content: createImageMarkerContent(shipIcon),
                        title: shipIcon.alt,
                    });

                    // Create the start marker.
                    startMarker = createAdvancedMarker({
                        position: ship,
                        visible: false,
                        content: createImageMarkerContent(startIcon),
                        title: startIcon.alt,
                        zIndex: 6,
                        clickable: true,
                    });

                    // Create the end marker.
                    endMarker = createAdvancedMarker({
                        position: ship,
                        visible: false,
                        content: createImageMarkerContent(endIcon),
                        title: endIcon.alt,
                        zIndex: 6,
                        clickable: true,
                    });

                    // Create the polyline.
                    poly = new google.maps.Polyline({
                        //strokeColor: "#a6a6a6",
                        strokeColor: "#48A6AD",
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                        zIndex: 2,
                    });

                    poly.setMap(myGoogleMap); // Add the polyline to the map

                    //removeGoogleFontsForMaps();

                    onMountedFinished = true; // Set onMountedFinished to true when the map is loaded

                    if (logbookItemsFetched) {
                        runLoop(); // Execute runLoop() if both conditions are met
                        console.log("Removing Google Fonts from onMounted()");
                        //delayBeforeRemovingFonts();
                    }

                });
            });

            // Watch for changes and execute runLoop() when items are populated and map is loaded.
            watch(dayItems, () => {
                if (!logbookItemsFetched && dayItems.value.length > 0) {
                    logbookItemsFetched = true;
                    if (onMountedFinished) {
                        runLoop(); // Execute runLoop() if both conditions are met
                        console.log("Removing Google Fonts from watch()");
                        //delayBeforeRemovingFonts();
                    }
                } else if (onMountedFinished && dayItems.value.length > 0) {
                    // If more updates come in after initial render, re-run
                    runLoop();
                }
            });

            return {
                formattedDate,
                map,
                goBack,
                tripData,
                carouselModel,
                showCarousel,
                menuItems,
                captureAndShareBase,
                getIconPath,
                showLoadingDialog,
                showShareDialog,
                shareNow,
                showHint,
                hintItems,
                showExtras,
                isFavourite,
                journeyId,
                showEditNicknameDialog,
                journey,
                updateJourney,
                saveJourney,
                hasGalleryAccess,
                isCaptain,
                showSaveDialog,
                goToGallery,
                nickname,
                description,
                deleteJourney,
                showDeleteDialog,
                captureLog,
                shareImageUrl,
            };
        },
    });
</script>

<style lang="scss" scoped>

    .logbook-page {
        height: 100%;
        overflow: hidden;
    }

    .logbook-layout {
        height: 100%;
        flex-direction: column;
        flex-wrap: nowrap;
    }

    .logbook-content {
        min-height: 0;
    }

    .logbook-header-row {
        flex: 0 0 auto;
        height: 60px;
        position: relative;
        z-index: 2;
    }

    .logbook-title {
        font-size: var(--app-font-body);
    }

    .logbook-map-wrap {
        position: relative;
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;
    }

    .logbook-map-wrap ::v-deep .gm-style {
        z-index: auto !important;
    }

    .logbook-map-wrap ::v-deep .gm-style > div[style*="z-index: 0"] {
        z-index: auto !important;
    }

    .logbook-map-wrap ::v-deep .gm-style .gm-style-mtc-bbw {
        z-index: 5 !important;
    }

    .logbook-map {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    /* Remove Google InfoWindow�s default white bubble/chrome */
    ::v-deep .gm-style .gm-style-iw-c {
        background: transparent !important;
        padding: 0 !important;
        box-shadow: none !important;
        border-radius: 14px !important;
    }

    ::v-deep .gm-style .gm-style-iw-d {
        overflow: visible !important; /* avoids inner scrollbars cutting edges */
        padding: 0 !important;
        background: transparent !important;
    }

    /* Hide the little white pointer (�tail�). Comment out if you want to keep it */
    ::v-deep .gm-style .gm-style-iw-t::after,
    ::v-deep .gm-style .gm-style-iw-t::before {
        display: none !important;
    }

    /* Nudge the default InfoWindow close button */
    ::v-deep .gm-style .gm-ui-hover-effect {
        top: 34px !important; /* push it DOWN a touch */
        right: 0px !important; /* move it a bit further RIGHT (closer to edge) */
        width: 28px !important;
        height: 28px !important;
        background: transparent !important;
        border-radius: 8px !important;
        box-shadow: none !important;
    }

    /* Keep the icon centered and white */
    ::v-deep .gm-style .gm-ui-hover-effect span {
        margin: 0 !important;
        width: 18px !important;
        height: 18px !important;
        background-color: #fff !important; /* the �X� color */
        opacity: 0.95;
    }

    ::v-deep .gm-style .gm-ui-hover-effect img {
        width: 16px !important;
        height: 16px !important;
        filter: invert(1) brightness(2); /* make it white for dark header */
        opacity: 0.9;
    }

    .align-center {
        display: flex;
        align-items: center;
    }

    .blackSheetStyle {
        z-index: 0;
    }

    .compassOnTop {
        position: fixed;
        bottom: 75px;
        right: -22px;
        transform: translateX(-50%);
        z-index: 8;
    }

    .switchOnTop {
        position: fixed;
        bottom: 75px;
        left: 30px;
        transform: translateX(-50%);
        z-index: 8;
    }

    .hintOnTop {
        position: fixed;
        bottom: 75px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 8;
    }

    .logoOnTop {
        position: absolute;
        top: 60px;
        left: 100%;
        transform: translateX(-100%);
        z-index: 8;
    }

    .dataCarousel {
        position: fixed;
        //bottom: 56px;
        top: 114px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 100%;
        z-index: 2;
        opacity: 1;
    }

    .dataSheetAutoHeight {
        position: fixed;
        top: 114px;
        //bottom: 56px;
        left: 2px;
        right: 0;
        margin: 0 auto;
        width: 60%;
        z-index: 2;
        opacity: 1;
        height: auto !important;
    }
    </style>